<template>
  <div
    id="mainbox"
    style="
      padding: 34px;
      background-color: #f1f4fa;
      height: calc(100vh - 51px);
      box-sizing: border-box;
      overflow: scroll;
    "
  >
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      "
    >
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin-bottom: 39px"
      >
        <el-breadcrumb-item
          v-for="(item, key) in breadcrumb"
          :key="key"
          :to="{ name: item.path }"
        >
          {{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" @click="showAddUserDialog = true"
        >添加用户</el-button
      >
    </div>
    <div
      style="
        background-color: #fff;
        overflow: hidden;
        padding: 0 36px;
        text-align: left;
      "
    >
      <div style="text-align: left; margin: 18px 0">查询</div>
      <div
        class="formBox"
        style="
          background: #ffffff;
          border: 2px solid #dcdfe6;
          display: inline-block;
        "
      >
        <el-form
          :inline="true"
          style="text-align: left"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="用户名">
            <el-input
              style="width: 200px"
              v-model="formInline.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              style="width: 200px"
              v-model="formInline.nickname"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              style="width: 200px"
              v-model="formInline.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                getList();
              "
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="id" label="用户ID"> </el-table-column>
          <el-table-column prop="username" label="用户名"> </el-table-column>
          <el-table-column prop="nickname" label="姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="is_used" label="是否启用">
            <template #default="scope">
              <span>{{ scope.row.is_used === 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_user" label="创建人">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template #default="scope">
              <el-button
                @click="showEditUserDialog(scope.row)"
                type="text"
                size="small"
                >编辑</el-button
              >
              <el-button
                @click="handleDelete(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
              <el-button
                @click="showDataPermission(scope.row)"
                type="text"
                size="small"
                >数据权限</el-button
              >
              <el-button
                @click="editDataPermission(scope.row)"
                type="text"
                size="small"
                >编辑权限</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin: 20px 0"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="添加用户" :visible.sync="showAddUserDialog" width="30%">
      <el-form :model="newUser" ref="newUserForm">
        <el-form-item
          label="用户名"
          :label-width="formLabelWidth"
          prop="username"
          :rules="[
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ]"
        >
          <el-input v-model="newUser.username"></el-input>
        </el-form-item>
        <el-form-item
          label="姓名"
          :label-width="formLabelWidth"
          prop="nickname"
          :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
        >
          <el-input v-model="newUser.nickname"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          :label-width="formLabelWidth"
          prop="mobile"
          :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ]"
        >
          <el-input v-model="newUser.mobile"></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input type="password" v-model="newUser.password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddUserDialog = false">取消</el-button>
        <el-button type="primary" @click="createUser">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑用户"
      :visible.sync="showEditUserDialogFlag"
      width="30%"
    >
      <el-form :model="editUser" ref="editUserForm">
        <el-form-item
          label="用户名"
          :label-width="formLabelWidth"
          prop="username"
        >
          <el-input v-model="editUser.username" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="姓名"
          :label-width="formLabelWidth"
          prop="nickname"
          :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
        >
          <el-input v-model="editUser.nickname"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          :label-width="formLabelWidth"
          prop="mobile"
          :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ]"
        >
          <el-input v-model="editUser.mobile"></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input type="password" v-model="editUser.password"></el-input>
        </el-form-item>
        <el-form-item
          label="是否启用"
          :label-width="formLabelWidth"
          prop="is_used"
          :rules="[
            { required: true, message: '请选择是否启用', trigger: 'change' },
          ]"
        >
          <el-select v-model="editUser.is_used" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditUserDialogFlag = false">取消</el-button>
        <el-button type="primary" @click="updateUser">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="数据权限"
      :visible.sync="showDataPermissionDialog"
      width="50%"
    >
      <div
        v-if="loadingDataPermission"
        style="text-align: center; margin-top: 20px"
      >
        <el-loading
          :loading="loadingDataPermission"
          text="Loading..."
        ></el-loading>
      </div>
      <el-table
        v-else
        :data="dataPermissionTableData"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column prop="brand_id" label="品牌ID"> </el-table-column>
        <el-table-column prop="brand_name" label="品牌名称"> </el-table-column>
        <el-table-column prop="agent_id" label="代理ID"> </el-table-column>
        <el-table-column prop="agent_name" label="代理名称"> </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDataPermissionDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UsersList",
  data() {
    return {
      breadcrumb: [{ name: "用户列表" }],
      tableData: [],
      formInline: { username: "", nickname: "", mobile: "" },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showAddUserDialog: false,
      showEditUserDialogFlag: false,
      showDataPermissionDialog: false,
      newUser: {
        username: "",
        nickname: "",
        mobile: "",
        password: "",
      },
      editUser: {
        id: "",
        username: "",
        nickname: "",
        mobile: "",
        password: "",
      },
      dataPermissionTableData: [],
      loadingDataPermission: false,
      formLabelWidth: "100px",
    };
  },
  methods: {
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get("/api/users/list", {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
            username: this.formInline.username,
            nickname: this.formInline.nickname,
            mobile: this.formInline.mobile,
          },
        })
        .then((response) => {
          loading.close();
          this.tableData = response.data.items;
          this.total = response.data.total;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          loading.close();
        });
    },
    reset() {
      this.currentPage = 1;
      this.formInline = { username: "", nickname: "", mobile: "" };
      this.getList();
    },
    createUser() {
      this.$refs.newUserForm.validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/users/create", this.newUser)
            .then(() => {
              this.$message({
                type: "success",
                message: "用户添加成功!",
              });
              this.showAddUserDialog = false;
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        }
      });
    },
    showEditUserDialog(row) {
      this.editUser = { ...row };
      this.showEditUserDialogFlag = true;
    },
    updateUser() {
      this.$refs.editUserForm.validate((valid) => {
        if (valid) {
          this.$axios
            .put(`/api/users/update/${this.editUser.username}`, this.editUser)
            .then(() => {
              this.$message({
                type: "success",
                message: "用户更新成功!",
              });
              this.showEditUserDialogFlag = false;
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确定要删除这个用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete(`/api/users/delete/${row.username}`)
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList();
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                this.$message.error(err.response.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    showDataPermission(row) {
      this.dataPermissionTableData = [];
      this.loadingDataPermission = true;
      this.showDataPermissionDialog = true;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post("/api/datap/listall", { user_id: parseInt(row.id) })
        .then((response) => {
          console.log("Response:", response);
          this.dataPermissionTableData = response.data.data;
          console.log("Data assigned to table:", response.data.data);
          this.loadingDataPermission = false;
          loading.close();
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          this.loadingDataPermission = false;
          loading.close();
        });
    },
    editDataPermission(row) {
      this.$router.push({
        path: "/dataplist",
        query: { user_id: row.id },
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
body {
  margin: 0;
}
</style>
